import React from "react";
import styled from "styled-components";


const Card = (props) =>{
    return(
        <Container>
            <Img src={props.image}/>
            <Title>{props.title}</Title>
            <br/>
            <Description>{props.description}</Description>
        </Container>
    )
};


export default Card;

const Img = styled.img`
width: 100%;
height: 80px;
object-fit: contain;
`;

const Container = styled.div`
width: 280px;
height: 230px;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
background-color: whitesmoke;
padding: 40px 20px;
border-radius: 10px;
margin: 10px 0;
box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;

:hover{
background: linear-gradient( 150deg ,indigo 30%, green 54.05%, orangered 65%);
background-clip: text;
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;
}

@media Screen and (max-width: 768px){
    width: 35%;
    margin: 5px;
}
@media Screen and (max-width: 768px){
    width: 60%;
    margin: 5px 0px;
}
@media Screen and (max-width: 375px){
    width: 90%;
    margin: 10px 0px;
}
`;
const Description = styled.div`
text-align: center;
`;
const Title = styled.div`
font-size: 25px;
`;